import { MgService } from 'src/app/services/mg.service';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout'

import { ChartsModule } from '@rinminase/ng-charts';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { DateAdapter, MatNativeDateModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatStepperModule } from '@angular/material/stepper';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTableModule } from '@angular/material/table';
import { MatDividerModule } from '@angular/material/divider';
import { MatChipsModule } from '@angular/material/chips';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorIntl } from '@angular/material/paginator';

import { NgxMaskModule, IConfig } from 'ngx-mask';
import { CdkMenuModule } from '@angular/cdk/menu';

import { HomeComponent } from './views/home/home.component';
import { HomeOperatorComponent } from './views/operator/home-operator/home-operator.component';
import { ListCallsComponent } from './views/operator/list-calls/list-calls.component';
import { SettingsComponent } from './views/operator/settings/settings.component';
import { CallCompleteComponent } from './views/operator/call-complete/call-complete.component';
import { OpenCallOperatorComponent } from './views/operator/open-call-operator/open-call-operator.component';
import { ClientCallDetailsComponent } from './views/client/client-call-details/client-call-details.component';
import { ClientLoginComponent } from './views/client/client-login/client-login.component';
import { OperatorLoginComponent } from './views/operator/operator-login/operator-login.component'

import { LoginClientLayoutComponent } from './layouts/login-client-layout/login-client-layout.component';
import { ClientLayoutComponent } from './layouts/client-layout/client-layout.component';
import { LoginOperatorLayoutComponent } from './layouts/login-operator-layout/login-operator-layout.component';
import { OperatorLayoutComponent } from './layouts/operator-layout/operator-layout.component';

import { OpenCallDialogComponent } from './components/user/open-call-dialog/open-call-dialog.component';
import { CallFormOperatorComponent } from './components/call/call-form-operator/call-form-operator.component';
import { BusinessSelectionComponent } from './components/business/business-selection/business-selection.component';
import { UserBusinessSelectionComponent } from './components/business/user-business-selection/user-business-selection.component';
import { CallDescriptionComponent } from './components/call/call-description/call-description.component';
import { MenuOperatorComponent } from './components/general/menu/menu-operator/menu-operator.component';
import { ToolbarOperatorComponent } from './components/general/menu/toolbar-operator/toolbar-operator.component';
import { MiniSquareBarComponent } from './components/data-shown/status-bar/mini-square-bar/mini-square-bar.component';
import { MiniSquareComponent } from './components/data-shown/status-bar/mini-square/mini-square.component';
import { YearDataChartComponent } from './components/data-shown/year-data-chart/year-data-chart.component';
import { DailyPhraseComponent } from './components/general/daily-phrase/daily-phrase.component';
import { ListCallItemOperatorComponent } from './components/call/list-call-item-operator/list-call-item-operator.component';
import { CallMainComponent } from './components/call-operator-page/call-main/call-main.component';
import { CallEntryComponent } from './components/call-operator-page/call-entry/call-entry.component';
import { CallNoteComponent } from './components/call-operator-page/call-note/call-note.component';
import { CallStatusComponent } from './components/call-operator-page/call-status/call-status.component';
import { CallBusinessComponent } from './components/call-operator-page/call-business/call-business.component';
import { CallBusinessUserComponent } from './components/call-operator-page/call-business-user/call-business-user.component';
import { CallDetailsComponent } from './components/call-operator-page/call-details/call-details.component';
import { CallTagComponent } from './components/call-operator-page/call-tag/call-tag.component';
import { CallNewEntryComponent } from './components/call-operator-page/call-new-entry/call-new-entry.component';
import { MenuClientComponent } from './components/general/menu/menu-client/menu-client.component';
import { ToolbarClientComponent } from './components/general/menu/toolbar-client/toolbar-client.component';
import { ChooseBusinessDialogComponent } from './components/call-operator-page/choose-business-dialog/choose-business-dialog.component';
import { ClientCallListComponent } from './views/client/client-call-list/client-call-list.component';

import { AuthService } from './services/auth.service';
import { AuthOperatorService } from './services/auth-operator.service';
import { ListCallItemClientComponent } from './components/call/list-call-item-client/list-call-item-client.component';
import { OpenOsDialogComponent } from './components/open-os-dialog/open-os-dialog.component';
import { UserChangePasswordComponent } from './components/user/user-change-password/user-change-password.component';
import { OpenCallWithoutRegisterComponent } from './components/open-call-without-register/open-call-without-register.component';
import { ListBusinessComponent } from './components/list/list-business/list-business.component';
import { ListUserComponent } from './components/list/list-user/list-user.component';
import { AddUserComponent } from './components/form/add-user/add-user.component';
import { AddBusinessComponent } from './components/form/add-business/add-business.component';
import { SelectBusinessComponent } from './components/register/user/select-business/select-business.component';
import { LoginDataComponent } from './components/register/user/login-data/login-data.component';
import { EditUserComponent } from './components/form/edit-user/edit-user.component';
import { ListBusinessUsersComponent } from './components/list/list-business-users/list-business-users.component';

import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { CallEntryItemCompromiseComponent } from './components/call-operator-page/call-entry-item-compromise/call-entry-item-compromise.component';
import { CallEntryItemResponseComponent } from './components/call-operator-page/call-entry-item-response/call-entry-item-response.component';
import { CallUserAgentComponent } from './components/call-operator-page/call-user-agent/call-user-agent.component';
import { FilterCallComponent } from './components/call/filter-call/filter-call.component';
import { KnowledgeBaseCallListComponent } from './components/knowledge-base/knowledge-base-call-list/knowledge-base-call-list.component';
import { KnowledgeBaseListComponent } from './components/knowledge-base/knowledge-base-list/knowledge-base-list.component';
import { CallFilesComponent } from './components/call-operator-page/call-files/call-files.component';
import { CallAttachmentsComponent } from './components/call-operator-page/call-attachments/call-attachments.component';
import { ListCallItemResponsiveComponent } from './components/call/list-call-item-responsive/list-call-item-responsive.component';
import { CustomPaginator } from './services/custom-paginator.service';
import { ListUserResponsiveComponent } from './components/list/list-user-responsive/list-user-responsive.component';
import { UserBusinessSelectionResponsiveComponent } from './components/business/user-business-selection-responsive/user-business-selection-responsive.component';
import { ListBusinessResponsiveComponent } from './components/list/list-business-responsive/list-business-responsive.component';
import { ClientHomeComponent } from './views/client/client-home/client-home.component';
import { UserChangeProfileComponent } from './components/user/user-change-profile/user-change-profile.component';
import { ClientProfileComponent } from './views/client/client-profile/client-profile.component';
import { ClientInvoiceListComponent } from './views/client/client-invoice-list/client-invoice-list.component';
import { InvoiceItemComponent } from './components/invoice/invoice-item/invoice-item.component';
import { InvoiceFilterComponent } from './components/invoice/invoice-filter/invoice-filter.component';

registerLocaleData(localePt);

export const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    SettingsComponent,
    OpenCallDialogComponent,
    CallFormOperatorComponent,
    BusinessSelectionComponent,
    UserBusinessSelectionComponent,
    CallDescriptionComponent,
    OpenCallOperatorComponent,
    MenuOperatorComponent,
    ToolbarOperatorComponent,
    MiniSquareBarComponent,
    MiniSquareComponent,
    YearDataChartComponent,
    DailyPhraseComponent,
    HomeOperatorComponent,
    ListCallsComponent,
    ListCallItemOperatorComponent,
    CallCompleteComponent,
    CallMainComponent,
    CallEntryComponent,
    CallNoteComponent,
    CallStatusComponent,
    CallBusinessComponent,
    CallBusinessUserComponent,
    CallDetailsComponent,
    CallTagComponent,
    CallNewEntryComponent,
    MenuClientComponent,
    ClientCallDetailsComponent,
    ClientLoginComponent,
    OperatorLoginComponent,
    ToolbarClientComponent,
    OperatorLayoutComponent,
    ClientLayoutComponent,
    LoginClientLayoutComponent,
    LoginOperatorLayoutComponent,
    ClientCallListComponent,
    ListCallItemClientComponent,
    OpenOsDialogComponent,
    UserChangePasswordComponent,
    OpenCallWithoutRegisterComponent,
    ListBusinessComponent,
    ListUserComponent,
    AddUserComponent,
    AddBusinessComponent,
    SelectBusinessComponent,
    LoginDataComponent,
    EditUserComponent,
    ListBusinessUsersComponent,
    CallEntryItemCompromiseComponent,
    CallEntryItemResponseComponent,
    CallUserAgentComponent,
    ChooseBusinessDialogComponent,
    FilterCallComponent,
    KnowledgeBaseCallListComponent,
    KnowledgeBaseListComponent,
    CallFilesComponent,
    CallAttachmentsComponent,
    ListCallItemResponsiveComponent,
    ListUserResponsiveComponent,
    UserBusinessSelectionResponsiveComponent,
    ListBusinessResponsiveComponent,
    ClientHomeComponent,
    UserChangeProfileComponent,
    ClientProfileComponent,
    ClientInvoiceListComponent,
    InvoiceItemComponent,
    InvoiceFilterComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatCardModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatNativeDateModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatButtonModule,
    MatSidenavModule,
    FlexLayoutModule,
    MatProgressSpinnerModule,
    MatStepperModule,
    MatExpansionModule,
    MatTableModule,
    MatDividerModule,
    CKEditorModule,
    MatChipsModule,
    MatToolbarModule,
    ChartsModule,
    MatPaginatorModule,
    MatSnackBarModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatGridListModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    NgxMaskModule.forRoot(maskConfig),
    CdkMenuModule,
  ],
  providers: [
    AuthService,
    AuthOperatorService,
    MgService,
    { provide: MatPaginatorIntl, useValue: CustomPaginator() },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-br' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
